// VLAN selector pills row.
import { MapPin, PencilSimple } from '@phosphor-icons/react';

export const isOmadaNet = (v) => v?.source === 'omada_network';

export const VlanPills = ({ vlans, activeVlan, onSelect, onEdit }) => (
  <div className="flex gap-2 flex-wrap">
    {vlans.map((v) => {
      const active = activeVlan?.id === v.id;
      return (
        <div
          key={v.id}
          data-testid={`vlan-tab-${v.key}`}
          onClick={() => onSelect(v)}
          className={`relative px-4 py-2.5 rounded-xl text-sm font-medium border transition-colors text-left cursor-pointer min-w-[190px] pr-7 ${
            active ? 'bg-teal-700 text-white border-teal-700' : 'bg-white text-zinc-700 border-slate-200 hover:border-slate-300'
          }`}
        >
          <div className="flex items-center gap-1.5">
            <span>{v.name}</span>
            {isOmadaNet(v) && <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${active ? 'bg-white/25 text-white' : 'bg-blue-50 text-blue-600'}`}>Omada</span>}
          </div>
          <div className={`text-xs ${active ? 'text-blue-100' : 'text-zinc-400'}`}>
            {v.assigned}/{v.total} 使用中{v.subnet ? ` · ${v.subnet}` : ''}
          </div>
          {v.note && <div className={`text-xs mt-0.5 flex items-center gap-1 ${active ? 'text-blue-100' : 'text-zinc-500'}`}><MapPin size={12} weight="fill" /> {v.note}</div>}
          <span
            role="button" tabIndex={0} data-testid={`edit-vlan-${v.key}`}
            onClick={(e) => { e.stopPropagation(); onEdit(v); }}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); onEdit(v); } }}
            className={`absolute top-1.5 right-1.5 p-1 rounded-md transition-colors ${active ? 'text-white hover:bg-white/20' : 'text-zinc-400 hover:bg-zinc-100'}`}
          >
            <PencilSimple size={14} />
          </span>
        </div>
      );
    })}
  </div>
);
